import { MenuItem, Select, Stack, Typography } from '@mui/material';

import ChevronDownIcon from '@/components/Icons/ChevronDownIcon';

import { ListOptionsProps } from './types';

function ListOptions<T extends string>({
  title,
  options,
  selectedOption,
  onOptionSelect,
  mapOptionToTitle,
}: ListOptionsProps<T>) {
  return (
    <Select
      value={selectedOption}
      IconComponent={ChevronDownIcon}
      onChange={(e) => onOptionSelect(e.target.value as T)}
      renderValue={(value: T) => (
        <Stack direction="row" alignItems="center" gap={0.5}>
          <Typography variant="h5" color="text.muted">
            {title}:
          </Typography>
          <Typography variant="h5">{mapOptionToTitle(value)}</Typography>
        </Stack>
      )}
    >
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {mapOptionToTitle(option)}
        </MenuItem>
      ))}
    </Select>
  );
}

export default ListOptions;
